import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState } from '@services/appstate.service';
import { HelperService } from '@services/helper.service';
import { TagActions } from '@actions/tag.actions';
import { getTagSearchResults } from '../../reducers';


@Component({
    selector: 'app-advance-query-dialog',
    templateUrl: './advance-query-dialog.component.html',
    styleUrls: ['./advance-query-dialog.component.scss']
})
export class AdvanceQueryDialogComponent implements OnInit {
    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: any): void {
        if (this.selectedTags != null && this.selectedTags.nativeElement != null && !this.selectedTags.nativeElement.contains(event.target)) {
            this.showSuggestionsType = '';
        }
    }
    @ViewChild('selectedTags') selectedTags: ElementRef;

    conditions: any = [];
    initialTagSearch = '';
    operator = 'AND';
    searching = false;
    tags$: Observable<any>;
    searchedTags: any;
    showSuggestionsType = '';
    tagString = '';
    type = '';

    constructor(
        private store: Store<AppState>,
        private tagActions: TagActions,
        private helperService: HelperService,
        private matDialogRef: MatDialogRef<any>
    ) {
        this.tags$ = store.pipe(getTagSearchResults());
        this.tags$.subscribe({
            next: (x) => {
                this.searchedTags = x.sort((a: any, b: any) => a.id.length - b.id.length);
                this.searching = false;
            }
        });
    }

    ngOnInit() {
        this.tagString = this.matDialogRef.componentInstance.tagString;
        this.type = this.matDialogRef.componentInstance.type;
        this.addOperator(true);
    }

    onKeyUp(event: any, value: any, type: any) {
        if (event.keyCode !== 13 && value.length > 2 && this.searching === false) { // dont do anything on enter
            this.searchTag(value);
            this.showSuggestionsType = type;
        }
    }

    searchTag(query: string) {
        if (query.length > 2 && this.searching === false) {
            this.searching = true;
            this.store.dispatch(this.tagActions.searchTag(query));
        }
    }

    checkSuggestionType(type: any) {
        if (type === this.showSuggestionsType) {
            return true;
        }
        return false;
    }

    setCondition(i: any, tag: any) {
        this.conditions[i].tag = tag.id;
        this.showSuggestionsType = '';
    }

    addOperator(initial = false, tag = '') {
        if (initial === true) {
            if (this.tagString !== '') {
                if (this.tagString.indexOf('AND') > 0) {
                    this.operator = 'AND';
                    const tagArray = this.tagString.split('AND');
                    for (let i = 0; i < tagArray.length; i++) {
                        this.conditions.push({
                            tag: tagArray[i].replace(/"/g, '').trim()
                        });
                    }
                } else if (this.tagString.indexOf('OR') > 0) {
                    this.operator = 'OR';
                    const tagArray = this.tagString.split('OR');
                    for (let i = 0; i < tagArray.length; i++) {
                        this.conditions.push({
                            tag: tagArray[i].replace(/"/g, '').trim()
                        });
                    }
                } else {
                    this.conditions.push({
                        tag: this.tagString.trim()
                    });
                }
            }
        } else {
            if (this.conditions != null && this.conditions.length > 0) {
                for (const condition of this.conditions) {
                    if (condition.tag === tag) {
                        return;
                    }
                }
            }
            this.conditions.push({
                tag
            });
        }
    }

    deleteOperator(i: any) {
        this.conditions.splice(i, 1);
    }

    closeDialog() {
        return {
            operator: this.operator,
            conditions: this.conditions
        }
    }
}
